import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { ContactPersonModel } from 'src/app/models/contact-person-model.model'
import * as _ from 'lodash'
import { FormArray, FormControl, FormGroup } from '@angular/forms'

@Component({
  selector: 'vendor-form',
  templateUrl: './vendor-form.component.html',
  styleUrls: ['./vendor-form.component.css']
})
export class VendorFormComponent implements OnInit {
  @Input() emptyFormSchema
  @Input() data
  @Output() removeFormEvent = new EventEmitter<any>()
  @Output() emittedData = new EventEmitter<any>()
  customForm
  @Input() type

  constructor() {}

  ngOnInit() {
    let cp = new ContactPersonModel('')
    this.emptyFormSchema['Contact Persons'] = []
    if (this.data) {
      this.data['Contact Persons'].forEach(() => {
        this.emptyFormSchema['Contact Persons'].push(cp)
      })
    } else {
      this.emptyFormSchema['Contact Persons'].push(cp)
    }
    let grp = {}
    let ar = []
    for (let field in this.emptyFormSchema) {
      if (_.isArray(this.emptyFormSchema[field])) {
        var sub = {}
        let mainAr = []
        let formAr = new FormArray([])
        this.emptyFormSchema[field].forEach((elem, index) => {
          var sub = {}
          let a = []
          for (let key in this.emptyFormSchema[field][index]) {
            if (this.data) {
              sub[key] = new FormControl(this.data[field][index][key])
            } else {
              sub[key] = new FormControl('')
            }
          }
          for (let key in this.emptyFormSchema[field][0]) {
            a.push([key, ''])
          }
          formAr.push(new FormGroup(sub))
          mainAr.push(a)
        })
        grp[field] = formAr
        ar.push([field, mainAr])
      } else if (
        _.isObject(this.emptyFormSchema[field]) &&
        !this.emptyFormSchema.hasOwnProperty('options')
      ) {
        let sub = {}
        for (let key in this.emptyFormSchema[field]) {
          if (this.data) {
            sub[key] = new FormControl(this.data[field][key])
          } else {
            sub[key] = new FormControl('')
          }
        }
        grp[field] = new FormGroup(sub)
        ar.push([field, this.emptyFormSchema[field]])
      } else {
        if (this.type == 'Add') {
          grp[field] = new FormControl('')
        } else if (this.type == 'Edit') {
          grp[field] = new FormControl(this.data[field])
        }
        ar.push([field, this.emptyFormSchema[field]])
      }
    }

    this.emptyFormSchema = ar
    this.customForm = new FormGroup(grp)
  }

  close() {
    this.removeFormEvent.emit()
  }

  submit() {
    this.emittedData.emit(this.customForm.value)
  }

  add(event) {}
}
